import { http } from "../../../../common/helpers/index";
import { baseUrl } from "../../../../common/config";

export const getChannelsService = () => {
  return http.get(`${baseUrl}/api/chat/channels/mine`);
};

export const getChannelHistoryService = (channelId) => {
  return http.get(`${baseUrl}/api/chat/history/${channelId}`);
};

export const sendMessageService = (data) => {
  return http.post(`${baseUrl}/api/chat/send`, data);
};

export const readMessageService = (channelId) => {
  return http.patch(`${baseUrl}/api/chat/channels/${channelId}/mark-as-read`);
};
